import React from 'react';
import styles from './TcsoDualFuelResultsScreen.module.css';
import buttonStyles from './TcsoInventoryCheckScreen.module.css';
import inputStyles from './TcsoDualFuelMeterDetailsScreen.module.css';
import BackButton from '../common/button/BackButton';
import SuccessIcon from '../common/icons/SuccessIcon';
import ErrorIcon from '../common/icons/ErrorIcon';
import { DualFuelCommsCheckResult } from '../../types/comms-check';
import { AddressSection, DeviceListSection, ReadingsSection } from './TcsoDualFuelResultSections';

/** Why the TCSO cannot go ahead although both meters are in comms; Start Chat replaces Confirm Site Details. */
export interface TcsoBlockedWarning {
  text: string;
  onStartChat: () => void;
}

interface TcsoDualFuelResultsScreenProps {
  result: DualFuelCommsCheckResult;
  warning?: TcsoBlockedWarning;
  onConfirm: () => void;
  onPrevious: () => void;
  onBackToStart: () => void;
}

const IN_COMMS_TEXT = 'Elec and Gas meters are in comms';

export default function TcsoDualFuelResultsScreen({
  result,
  warning,
  onConfirm,
  onPrevious,
  onBackToStart,
}: TcsoDualFuelResultsScreenProps) {
  return (
    <div className={`commsCheckDecommFlexContainer ${inputStyles.screenContainer}`}>
      <div className={'commsCheckDecommContent'}>
        <div className={'m-t-8'}>
          <BackButton onClick={onBackToStart} />
          <div className={styles.successBanner}>
            <SuccessIcon className={styles.bannerIcon} />
            <div className={styles.successBannerText}>
              {warning ? IN_COMMS_TEXT : `${IN_COMMS_TEXT}. Confirm site details below to proceed with TCSO`}
            </div>
          </div>
          {warning && (
            <div className={styles.errorBanner}>
              <ErrorIcon className={styles.bannerIcon} />
              <div className={styles.errorBannerBody}>
                <p className={styles.errorBannerText}>{warning.text}</p>
              </div>
            </div>
          )}
          <div className={styles.resultsPanel}>
            <AddressSection address={result.xrinv.address as string} />
            <ReadingsSection heading="Reading for Elec MSN" xritm={result.elecXritm} />
            <ReadingsSection heading="Reading for Gas MSN" xritm={result.gasXritm} />
            <DeviceListSection devices={result.xrinv.data} />
          </div>
        </div>
      </div>
      <div className={`tcsoFooter ${inputStyles.footer}`}>
        {warning ? (
          <button
            className={`${buttonStyles.tcsoTimeoutButton} ${buttonStyles.bgcGreen} ${buttonStyles.mGB8}`}
            onClick={warning.onStartChat}
          >
            Start Chat
          </button>
        ) : (
          <button
            className={`${buttonStyles.tcsoTimeoutButton} ${buttonStyles.bgcGreen} ${buttonStyles.mGB8}`}
            onClick={onConfirm}
          >
            Confirm Site Details
          </button>
        )}
        <button className={`${buttonStyles.tcsoTimeoutButton} ${buttonStyles.bgcDefault}`} onClick={onPrevious}>
          Previous
        </button>
      </div>
    </div>
  );
}
